import { graphql } from "react-relay";

export const SUBSCRIBE_TO_OFFER_MUTATION = graphql`
	mutation subscribeButton_SubscribeToOfferMutation($offerId: ID!) {
		Admin {
			Offer {
				subscribeToOffer(offerId: $offerId) {
					kind
					... on SubscribeBlocked {
						missingElementTypes
					}
				}
			}
		}
	}
`;
